import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="loader-screen">
          <p style={{ maxWidth: 420, textAlign: "center", lineHeight: 1.6 }}>
            Something went wrong. Try refreshing the page.
            <br />
            If this keeps happening, check the browser console.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
